module.exports = __webpack_public_path__ + "static/media/account-scale.104b5fed.svg";